<script>
	export let name;
	import NewsList from './NewsList.svelte';
	
</script>


<NewsList />
<main>
</main>
<div id="support-section" style="background-color: #f9f9f9; padding: 20px; text-align: center; margin-top: 20px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
	<h2>Support OnlyGoodNews.Today</h2>
	<p>OnlyGoodNews.Today brings you positive news every day, but we need your support to keep our services running. The sentiment analysis tools we use to curate the best content are costly.</p>
	<p>If you would like to support us, please consider making a donation:</p>
	<a href="https://www.patreon.com/onlygoodnewstoday">Support us on Patreon</a>
</div>